import { useCallback, useState } from "react";

export function useToggle(initialState = false) {
  const [toggle, setToggle] = useState(initialState);
  const onToggle = useCallback(
    (valor) => setToggle(typeof valor === "boolean" ? valor : !toggle),
    [toggle]
  );
  return { toggle, onToggle };
}
